import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { TeamModel } from 'types/Schedule.types';

export const teamToDoc = (team: TeamModel): DocumentData => {
  return {
    teamAbv: team.teamAbv,
    teamCity: team.teamCity,
    teamName: team.teamName,
    teamID: team.teamID,
    division: team.division,
    conferenceAbv: team.conferenceAbv,
    conference: team.conference,
    logoLgUrl: team.logoLgUrl,
    logoSmUrl: team.logoSmUrl,
  };
};

export const teamConverter: FirestoreDataConverter<TeamModel> = {
  toFirestore(team: TeamModel): DocumentData {
    // return { ...gameToDoc(game), ...getModifiedInfo() };
    return teamToDoc(team);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): TeamModel {
    const team = docSnap.data(options);

    return {
      teamAbv: team.teamAbv,
      teamCity: team.teamCity,
      teamName: team.teamName,
      teamID: team.teamID,
      division: team.division,
      conferenceAbv: team.conferenceAbv,
      conference: team.conference,
      logoLgUrl: team.logoLgUrl,
      logoSmUrl: team.logoSmUrl,
    };
  },
};
